import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import config from "config";

import { Card, Box } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle"; // for green bullet
import MDTypography from "components/MDTypography";

function MetroStatusCard() {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    async function getStatus() {
      try {
        const response = await axios.get(
          `${config.TRAFFIC}/latest_metro_status`,
          {
            headers: {
              "Content-Type": "application/json",
              "accept-profile": "infohub",
            },
          }
        );
        if (response?.data) {
          setStatus(response.data[0]); // Adjust based on actual response structure
        }
      } catch (error) {
        console.error("Error fetching metro status:", error);
        setStatus(null);
      }
    }

    getStatus();

    const interval = setInterval(getStatus, 15 * 60 * 1000); // 15 minutes

    return () => clearInterval(interval);
  }, []);

  const isNormal = status?.status_en === "Normal Operation";
  const bulletColor = isNormal ? "limegreen" : "red";

  return (
    <Card sx={{ p: 2, background: "#1a2035" }}>
      <MDTypography fontWeight="bold" variant="h6">
        {t("trafficMonitoring.infohub.metroStatus.title")}
      </MDTypography>

      {status ? (
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <CircleIcon
              sx={{ color: bulletColor, fontSize: "0.6rem", mr: 1 }}
            />
            <MDTypography variant="body2">
              {status.status_en || t("trafficMonitoring.infohub.metroStatus.normalOperation")}
            </MDTypography>
          </Box>
          <MDTypography
            variant="caption"
            sx={{
              mt: 0.5,
              display: "block",
              whiteSpace: "normal",
              lineHeight: 1.3,
              opacity: status.detail_en ? 1 : 0,
            }}
          >
            {status.detail_en || ""}
          </MDTypography>
        </Box>
      ) : (
        <MDTypography variant="body2" sx={{ mt: 1 }}>
          {t("trafficMonitoring.infohub.metroStatus.loading")}
        </MDTypography>
      )}
    </Card>
  );
}

export default MetroStatusCard;
